const KEYWORD_SUFFIX = ' :';

export function toKeyword(text: string): string {
  return text.toUpperCase() + KEYWORD_SUFFIX;
}
